module.exports = __webpack_public_path__ + "9df78497d52e24a0297b4247bc101a14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/treasurer-signup.svg
// module id = 3122
// module chunks = 0 1